import $ from 'jquery';

function checkComplexAnimationSupport() {
    const userAgent = window.navigator.userAgent;

    if (userAgent.match('Android')) {
        const androidVersion = userAgent.match(/Android (\d+(?:\.\d+(?:\.\d+)?)?)/)[1];
        $('body').addClass('is-android');

        if (userAgent.match('Android SDK')) {
            // We're inside an emulator. Because animations cause bugs in the accessibility layer
            // which is used for automatic testing, we switch them off here.
            return false;
        }
        if (parseInt(androidVersion, 10) >= 5) {
            return true;
        }
    }

    if (userAgent.match('iPhone') || userAgent.match('iPad')) {
        const iOSVersion = userAgent.match(/OS (\d+_\d+(_\d+)?) like Mac OS X/)[1];
        $('body').addClass('is-ios');
        if (parseInt(iOSVersion, 10) >= 8) {
            return true;
        }
    }

    if (userAgent.match('Chrome')) {
        const chromeVersion = userAgent.match(/Chrome\/(\d+)\./)[1];
        $('body').addClass('is-chrome');
        if (parseInt(chromeVersion, 10) >= 50 && !userAgent.match(/Mobile/)) {
            return true;
        }
    }

    return false;
}

function optimizePerformance() {
    // console.log('Checking browser performance…', window.navigator.userAgent);
    $(() => {
        if (checkComplexAnimationSupport()) {
            $('body').addClass('enable-complex-animations');
        }
    });
}

export default optimizePerformance;



// WEBPACK FOOTER //
// ./src/lib/performance.jsx